import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./header";
import Menu from "../components/layout/Menu";

const ScrollToTop: React.FC = () => {
  // hooks
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const MainLayout: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  // renders
  return (
    <div className="w-full min-h-screen overflow-x-hidden flex flex-col items-center bg-gray-50">
      <ScrollToTop />
      {/* Menu is now always mounted but handles its own visibility state via css transforms */}
      <Menu setIsOpen={setIsOpen} isOpen={isOpen} />
      
      <div
        className="w-full flex flex-col h-screen"
        onClick={() => {
           if(isOpen) setIsOpen(false);
        }}
      >
        <Header setMenuOpen={setIsOpen} />
        <div className="w-full flex-1 overflow-hidden relative">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
